// extracted by mini-css-extract-plugin
module.exports = {"formattedDate":"F-formatted-date-formatted-date-2B94Z"};